import { CE_MODAL_CLOSE } from "@js/actions/studio/modals.js";

export const CE_MODAL_INSERT_CUSTOM_FIELD_OPEN =
  "CE_MODAL_INSERT_CUSTOM_FIELD_OPEN";
export const ceModalInsertCustomFieldOpen = () => ({
  type: CE_MODAL_INSERT_CUSTOM_FIELD_OPEN,
});

export const ceModalInsertCustomFieldClose = () => ({
  type: CE_MODAL_CLOSE,
});
